// extracted by mini-css-extract-plugin
export default {"customSelect":"LangSelect_customSelect__sh01e","selectedOption":"LangSelect_selectedOption__749ZP"};